"use strict";
/* eslint-disable import/no-dynamic-require */

var _require = require('./browser'),
    registerTemplates = _require.registerTemplates;

var _require2 = require(process.env.REACT_STATIC_TEMPLATES_PATH),
    templates = _require2["default"],
    notFoundTemplate = _require2.notFoundTemplate;

registerTemplates(templates, notFoundTemplate);

if (typeof document !== 'undefined' && module && module.hot) {
  module.hot.accept(process.env.REACT_STATIC_TEMPLATES_PATH, function () {
    var _require3 = require(process.env.REACT_STATIC_TEMPLATES_PATH),
        templates = _require3["default"],
        notFoundTemplate = _require3.notFoundTemplate;

    registerTemplates(templates, notFoundTemplate);
  });
} //# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9ib290c3RyYXBUZW1wbGF0ZXMuanMiXSwibmFtZXMiOlsicmVxdWlyZSIsInJlZ2lzdGVyVGVtcGxhdGVzIiwicHJvY2VzcyIsImVudiIsIlJFQUNUX1NUQVRJQ19URU1QTEFURVNfUEFUSCIsInRlbXBsYXRlcyIsIm5vdEZvdW5kVGVtcGxhdGUiLCJkb2N1bWVudCIsIm1vZHVsZSIsImhvdCIsImFjY2VwdCJdLCJtYXBwaW5ncyI6Ijs7QUFBQTtlQUU4QkEsT0FBTyxDQUFDLFdBQUQsQztJQUE3QkMsaUIsWUFBQUEsaUI7O2dCQUV5Q0QsT0FBTyxDQUFDRSxPQUFPLENBQUNDLEdBQVIsQ0FDdERDLDJCQURxRCxDO0lBQXZDQyxTO0lBQVdDLGdCLGFBQUFBLGdCOztBQUc1QkwsaUJBQWlCLENBQUNJLFNBQUQsRUFBWUMsZ0JBQVosQ0FBakI7O0FBRUEsSUFBSSxPQUFPQyxRQUFQLEtBQW9CLFdBQXBCLElBQW1DQyxNQUFuQyxJQUE2Q0EsTUFBTSxDQUFDQyxHQUF4RCxFQUE2RDtBQUMzREQsRUFBQUEsTUFBTSxDQUFDQyxHQUFQLENBQVdDLE1BQVgsQ0FBa0JSLE9BQU8sQ0FBQ0MsR0FBUixDQUFZQywyQkFBOUIsRUFBMkQsWUFBTTtBQUFBLG9CQUNkSixPQUFPLENBQUNFLE9BQU8sQ0FBQ0MsR0FBUixDQUN0REMsMkJBRHFELENBRE87QUFBQSxRQUM5Q0MsU0FEOEM7QUFBQSxRQUNuQ0MsZ0JBRG1DLGFBQ25DQSxnQkFEbUM7O0FBRy9ETCxJQUFBQSxpQkFBaUIsQ0FBQ0ksU0FBRCxFQUFZQyxnQkFBWixDQUFqQjtBQUNELEdBSkQ7QUFLRCIsInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludC1kaXNhYmxlIGltcG9ydC9uby1keW5hbWljLXJlcXVpcmUgKi9cblxuY29uc3QgeyByZWdpc3RlclRlbXBsYXRlcyB9ID0gcmVxdWlyZSgnLi9icm93c2VyJylcblxuY29uc3QgeyBkZWZhdWx0OiB0ZW1wbGF0ZXMsIG5vdEZvdW5kVGVtcGxhdGUgfSA9IHJlcXVpcmUocHJvY2Vzcy5lbnZcbiAgLlJFQUNUX1NUQVRJQ19URU1QTEFURVNfUEFUSClcblxucmVnaXN0ZXJUZW1wbGF0ZXModGVtcGxhdGVzLCBub3RGb3VuZFRlbXBsYXRlKVxuXG5pZiAodHlwZW9mIGRvY3VtZW50ICE9PSAndW5kZWZpbmVkJyAmJiBtb2R1bGUgJiYgbW9kdWxlLmhvdCkge1xuICBtb2R1bGUuaG90LmFjY2VwdChwcm9jZXNzLmVudi5SRUFDVF9TVEFUSUNfVEVNUExBVEVTX1BBVEgsICgpID0+IHtcbiAgICBjb25zdCB7IGRlZmF1bHQ6IHRlbXBsYXRlcywgbm90Rm91bmRUZW1wbGF0ZSB9ID0gcmVxdWlyZShwcm9jZXNzLmVudlxuICAgICAgLlJFQUNUX1NUQVRJQ19URU1QTEFURVNfUEFUSClcbiAgICByZWdpc3RlclRlbXBsYXRlcyh0ZW1wbGF0ZXMsIG5vdEZvdW5kVGVtcGxhdGUpXG4gIH0pXG59XG4iXX0=


void function register() {
  /* react-hot-loader/webpack */
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }
  /* eslint-disable camelcase, no-undef */


  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports;
  /* eslint-enable camelcase, no-undef */

  if (!webpackExports) {
    return;
  }

  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/react-static/lib/bootstrapTemplates.js");
    return;
  }
  /* eslint-disable no-restricted-syntax */


  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */
    if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }

    var namedExport = void 0;

    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }

    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/react-static/lib/bootstrapTemplates.js");
  }
}();